import { createStyles } from 'antd-style'

export const useFormStyles = createStyles(({ prefixCls, token }) => ({
  form: {
    width: 320,
    background: token.colorWhite
  },
  submitBtn: {
    marginBlockStart: token.margin
  },
  forget: {
    position: 'relative',
    top: -token.marginXS,
    fontSize: token.fontSizeSM,
    textAlign: 'right',
    ['a']: {
      color: token.colorTextQuaternary
    }
  }
}))
